import { Typography, Stack, Link } from "@material-ui/core";
import { Box } from "@material-ui/system";
import { CustomRouterLink } from "./CustomRouterLink";

export const AppFooter = () => {
  return (
    <Box
      alignSelf="stretch"
      height="282px"
      display="flex"
      justifyContent="center"
      pt="40px"
      sx={{
        backgroundColor: "#23292F",
      }}
    >
      <Box width="1280px" pl="88px">
        <Box minWidth="600px" display="flex">
          <Stack>
            <Typography variant="bold" fontSize="21px" color="white">
              ABOUT
            </Typography>

            <Link
              target="_blank"
              href="/Wetez_onepage.pdf"
              underline="none"
              mt="18px"
            >
              <Typography fontSize="17px" color="#C2C2C2">
                Onepage
              </Typography>
            </Link>

            <Link
              target="_blank"
              href="https://www.stafi.io/stakingFinance"
              underline="none"
              mt="2px"
            >
              <Typography fontSize="17px" color="#C2C2C2">
                Staking Finance
              </Typography>
            </Link>

            <CustomRouterLink to="/contactUs">
              <Typography fontSize="17px" color="#C2C2C2" mt="2px">
                Contact us
              </Typography>
            </CustomRouterLink>
          </Stack>

          <Stack ml="55px">
            <Typography variant="bold" fontSize="21px" color="white">
              RESOURCES
            </Typography>

            <CustomRouterLink to="/stakingPools" mt="18px">
              <Typography fontSize="17px" color="#C2C2C2">
                Staking Services
              </Typography>
            </CustomRouterLink>

            <Link
              target="_blank"
              href="https://docs.wetez.io/wetez/"
              underline="none"
              mt="2px"
            >
              <Typography fontSize="17px" color="#C2C2C2">
                Documentation
              </Typography>
            </Link>
          </Stack>

          <Stack ml="100px">
            <Typography variant="bold" fontSize="21px" color="white">
              COMMUNITY
            </Typography>

            <Link
              target="_blank"
              href="https://twitter.com/Wetez_stake"
              underline="none"
              mt="18px"
            >
              <Typography fontSize="17px" color="#C2C2C2">
                Twitter
              </Typography>
            </Link>

            <Link
              target="_blank"
              href="https://medium.com/@wetezvalidator"
              underline="none"
              mt="2px"
            >
              <Typography fontSize="17px" color="#C2C2C2">
                Medium
              </Typography>
            </Link>

            <Link
              target="_blank"
              href="https://t.me/wetezann"
              underline="none"
              mt="2px"
            >
              <Typography fontSize="17px" color="#C2C2C2">
                Telegram
              </Typography>
            </Link>
          </Stack>

          <Stack ml="80px">
            <Typography variant="bold" fontSize="21px" color="white">
              TERMS
            </Typography>

            <CustomRouterLink to="/userAgreement" mt="18px">
              <Typography fontSize="17px" color="#C2C2C2">
                User Service Agreement
              </Typography>
            </CustomRouterLink>

            <CustomRouterLink to="/privacyPolicy" mt="2px">
              <Typography fontSize="17px" color="#C2C2C2">
                Privacy Policy
              </Typography>
            </CustomRouterLink>
          </Stack>
        </Box>
        <Box mt="50px">
          <Link
            target="_blank"
            href="https://forms.gle/zxgjAEkL59uMc29b6"
            style={{
              textDecorationColor: "#FFFFFF"
            }}
          >
            <Typography fontSize="17px"  variant="bold"  color="#FFFFFF">
              Invite Wetez as a service provider
            </Typography>
          </Link>
        </Box>
      </Box>
    </Box>
  );
};
